import React, { MouseEvent } from 'react'

import './circle-btn.sass'

type Props = {
  text?: string
  className?: string
  iconClassName: string
  buttonClassName?:string
  disabled?: boolean
  onClick: (me: MouseEvent) => void
}

export default class CircleBtn extends React.Component<Props> {

  render() {
    return (<>
      <div className={this.props.className}>
        <button title={this.props.text} className={`btn ${this.props.buttonClassName || ""} ` + (this.props.disabled ? 'disabled' : '')}
          onClick={this.props.onClick}>
          <span className={this.props.iconClassName}></span>
        </button>

        {/* {this.props.text ? (
          <div className="badge text-body">
            <span> {this.props.text} </span>
          </div>
        ) : ''} */}
      </div>
    </>)
  }
}

